export default __webpack_public_path__ + "static/AMA20 Finalist Medal_Brokerage of the Year - 6-20 Staff-8cdce698adb855ef25600809f38e0819.png";